// Subdomain-aware site config.
// In production on *.futra.pro we route across subdomains; in the preview
// (single host) everything falls back to same-origin path routing so nothing breaks.
const host = typeof window !== "undefined" ? window.location.hostname : "";
const isFutra = host.endsWith("futra.pro");
const sub = host.split(".")[0];

export const SITE = {
  host,
  isFutra,
  isAppHost: sub === "app",
  isDocsHost: sub === "docs",
  isAdminHost: sub === "admin",
  marketing: "https://futra.pro",
  app: "https://app.futra.pro",
  docs: "https://docs.futra.pro",
  admin: "https://admin.futra.pro",
  api: "https://api.futra.pro",
};

// Enter the app platform: cross-subdomain redirect in prod, SPA navigation in preview.
export function enterApp(navigate, path = "/app") {
  if (SITE.isFutra && !SITE.isAppHost) {
    window.location.href = SITE.app + path;
    return;
  }
  navigate(path);
}

export const docsHref = () => (SITE.isFutra ? SITE.docs : "/docs");
export const marketingHref = () => (SITE.isFutra ? SITE.marketing : "/");
export const adminHref = () => (SITE.isFutra ? SITE.admin : "/admin");
